<template>
  <v-dialog v-model="show">
    <template #activator="{ on }">
      <v-btn
        v-bind="$attrs"
        v-on="on"
      >
        Add album from {{ integration.name }}
      </v-btn>
    </template>

    <v-card
      v-if="!client || client.loading"
    >
      <v-card-title>
        <v-progress-circular
          color="primary"
          indeterminate
          style="margin: 0 auto"
        />
      </v-card-title>
    </v-card>

    <v-list v-else>
      <v-list-item
        v-for="album in albums"
        :key="`album-${album.id}`"
        @click="onClickAlbum(album)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ album.title }}
          </v-list-item-title>

          <v-list-item-subtitle>
            {{ album.mediaItemsCount }} photos
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="albums.length === 0">
        <v-list-item-title>
          No albums found!
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-dialog>
</template>

<script>
import GooglePhotoClient from '@/integrations/GooglePhotoClient'

export default {
  props: {
    integration: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      albums: [],
      client: null,
      show: false
    }
  },
  watch: {
    show (open) {
      if (open) {
        this.fetchAlbums()
      }
    }
  },
  methods: {
    async fetchAlbums () {
      this.client = new GooglePhotoClient(this.integration.accessToken)
      this.albums = await this.client.listAlbum()
    },
    onClickAlbum (album) {
      this.$emit('pick', `${this.integration.id}://${album.id}`)
      this.show = false
    }
  }
}
</script>
